import configs from 'configs';
import { SET_AVATAR, AVATARS_REQUEST, AVATARS_SUCCESS } from 'constants/actionTypes';
import Fetch from 'helpers/fetch';
import { dataURLtoFile } from 'helpers/avatar';
import { generateUrlQuery } from 'helpers/generateUrlQuery';

const { API_MEDIA_URL } = configs;

export const saveAvatar = (avatar, teamId, isHeaderImage) => async (
  dispatch,
  getState,
) => {
  const { auth, teams } = getState();

  const teamToken = teams.info[teamId]?.ownerAccount.token;

  const file = dataURLtoFile(avatar.data);
  const data = new FormData();
  data.append('avatar', file);

  const { result, error } = await Fetch.POST(
    `/uploadAvatar${isHeaderImage ? `?isHeader=${isHeaderImage}` : ''}`,
    {
      action: SET_AVATAR,
      url: API_MEDIA_URL,
      isFormData: true,
      headers: {
        Accept: '*/*',
        'x-access-token': teamId ? teamToken : auth.user?.token,
      },
      body: data,
    },
  );

  if (error) {
    return { error };
  }

  return result;
};

export const fetchAvatars = ids => async (dispatch, getState) => {
  const { auth } = getState();

  let params = {};
  params['token'] = auth.user?.token || localStorage.getItem('mpToken');
  params['accounts'] = ids;

  let url = generateUrlQuery(params);

  const { result } = await Fetch.GET(`/getAvatars${url}`, {
    action: AVATARS_REQUEST,
    url: API_MEDIA_URL,
  });

  dispatch({
    type: AVATARS_SUCCESS,
    payload: result.avatars,
  });
};
